import { useContext } from "react";
import { useParams } from "react-router-dom";

import { DeliveryEndpointType } from "../../../../common/types/DeliveryEndpointType";
import { useAdminDeliveryEndpointApi } from "../../api/useAdminDeliveryEndpointApi";
import { DeliveryEndpointContext } from "../../context/DeliveryEndpointContext";
import { CreateDeliveryEndpointFormInputs } from "./CreateAsperaDeliveryEndpointForm";

export const useCreateAsperaDeliveryEndpointForm = () => {
    const { createDeliveryEndpoint } = useAdminDeliveryEndpointApi();

    const { addAsperaDeliveryEndpointItem } = useContext(DeliveryEndpointContext);

    const { integratorId } = useParams<{ integratorId: string }>();

    const addDeliveryEndpoint = async ({
        name,
        url,
        user,
        ssmPrivateKeyName,
        workspace
    }: CreateDeliveryEndpointFormInputs): Promise<void> => {
        const { entityId } = await createDeliveryEndpoint({
            integratorId,
            name,
            url,
            user,
            ssmPrivateKeyName,
            type: DeliveryEndpointType.Aspera,
            workspace
        });

        addAsperaDeliveryEndpointItem({
            id: entityId,
            name,
            details: { type: DeliveryEndpointType.Aspera, url, user, ssmPrivateKeyName, workspace: workspace },
            type: DeliveryEndpointType.Aspera,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        addDeliveryEndpoint
    };
};
